<div class="option d-flex align-items-center">
  <span class="text-gradient" i18n="@@search-results.option">
    Option
  </span>
  <div class="fill"></div>
  <div class="border"></div>
</div>